/**
 * Huella de contenido de una foto de la bandeja de salida.
 *
 * Es la IDENTIDAD de la foto en la cola (spec 2026-10-01-photo-outbox-identity
 * § 5.2): dos entradas con la misma huella son la misma foto aunque su fichero
 * se llame distinto o lleven otro número de secuencia. Antes la identidad era la
 * posición `(orden, secuencia)`, y eso hacía que re-guardar borrase el fichero
 * de la entrada nueva y que una segunda edición sustituyese en silencio las
 * fotos de la primera.
 *
 * Devuelve `null` si no se puede calcular (sin `crypto.subtle` o fichero
 * ilegible). La cola trata entonces la foto como única: ante la duda, duplicar
 * antes que perder (D4).
 */
export async function photoFingerprint(blob: Blob): Promise<string | null> {
  try {
    const subtle = globalThis.crypto?.subtle;
    if (!subtle) return null;
    const digest = await subtle.digest('SHA-256', await blob.arrayBuffer());
    const hex = Array.from(new Uint8Array(digest), (byte) =>
      byte.toString(16).padStart(2, '0'),
    ).join('');
    return `sha256:${hex}`;
  } catch {
    return null;
  }
}
